import { render, staticRenderFns } from "./Examen.vue?vue&type=template&id=e90c0e0e&"
import script from "./Examen.vue?vue&type=script&lang=js&"
export * from "./Examen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QSelect,QSpace,QBtn,QSeparator,QToolbarTitle,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QSelect,QSpace,QBtn,QSeparator,QToolbarTitle,QTable,QTd})
